import { apiClient } from '@/hooks/useAxios';
import { CommonRes } from '@/types';

const ApiPath = '/avatar';

export const getViewUrl = async (): Promise<CommonRes<{ url: string }>> => {
  const res = await apiClient.get<CommonRes<{ url: string }>>(
    `${ApiPath}/view-url`,
  );
  return res.data;
};

export const uploadAvatar = async (
  file: File,
): Promise<CommonRes<{ objectPath: string }>> => {
  const form = new FormData();
  form.append('avatar', file);
  const res = await apiClient.post<CommonRes<{ objectPath: string }>>(
    `${ApiPath}/upload`,
    form,
    { headers: { 'Content-Type': 'multipart/form-data' } },
  );
  return res.data;
};
